import { z } from 'zod';

import { BookTypeEnum } from '../../enums';
import { levelEnumValidator } from '../../validators';
import { PaginationQuerySchema } from '../pagination';

export const BooksQuerySchema = PaginationQuerySchema.extend({
  levels: z
    .preprocess((val) => {
      if (typeof val === 'string' && val.length > 0) {
        return val.split(',');
      }
      return Array.isArray(val) ? val : undefined;
    }, z.array(levelEnumValidator).optional())
    .describe('Filter by an array of levels'),
  types: z
    .preprocess(
      (val) => {
        if (typeof val === 'string' && val.length > 0) {
          return val.split(',');
        }
        return Array.isArray(val) ? val : undefined;
      },
      z.array(z.nativeEnum(BookTypeEnum)).optional(),
    )
    .describe('Filter by an array of book types'),
  author: z.string().optional(),
  title: z.string().optional(),
});

export type IBooksQueryDto = z.infer<typeof BooksQuerySchema>;
